(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CivicPlusSwitchers", [], factory);
	else if(typeof exports === 'object')
		exports["CivicPlusSwitchers"] = factory();
	else
		root["CivicPlusSwitchers"] = factory();
})(self, () => {
return 